import React, { FC, useEffect } from 'react';
import styled from 'styled-components';
import { useLocation } from 'react-router-dom';
import type { RouteChildrenProps } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ErrorModal from '../../components/shared/CustomModal/ErrorModal';
import OnlyTeamContentModal from '../../components/shared/CustomModal/OnlyTeamContentModal';
import NoContentModal from '../../components/shared/CustomModal/NoContentModal';
import useRemoveQueryParams from '../../hooks/useRemoveQueryParams';
import { authSelector } from '../../store/auth/auth.selectors';
import Feed from '../Feed/Feed';
import CustomIntercomLauncher from '../../components/shared/CustomIntercomLauncher';
import { orgSelector } from '../../store/organization/organization.selectors';
import { organizationHasFeatureFlagSelector } from '../../store/profile/profile.selectors';
import { Features } from '../../utils/featureFlag/featureFlag.types';
import AskMeAnythingBottomSheet from './components/AskMeAnythingBottomSheet';
import useClassName from '../../hooks/useClassName';
import { isMobile } from 'react-device-detect';
import gtmTrack from '../../services/googleTagManager/track';

const Home: FC<RouteChildrenProps> = () => {
  const location = useLocation<{ hasFinishedContent?: boolean }>();
  const auth = useSelector(authSelector);
  const { id: orgId } = useSelector(orgSelector);
  const askAiFeatureFlag = useSelector(
    organizationHasFeatureFlagSelector({
      orgId,
      feature: Features.ASK_AI_FEED,
    }),
  );

  useClassName({ target: !isMobile && document.body, className: 'bg-gray' });
  useRemoveQueryParams(['timestamp']);

  useEffect(() => {
    gtmTrack('pageview', {
      page_title: 'feed',
    });
  }, []);

  return (
    <>
      <ErrorModal />
      <NoContentModal />
      <OnlyTeamContentModal />
      {location.state?.hasFinishedContent && (
        <S.WellDoneContainer>
          <S.WellDoneText>Well done{auth?.first_name ? `, ${auth.first_name}!` : '!'}</S.WellDoneText>
        </S.WellDoneContainer>
      )}
      <Feed />
      <CustomIntercomLauncher marginBottom={askAiFeatureFlag ? 75 : undefined} />
      <AskMeAnythingBottomSheet />
    </>
  );
};

const S = {
  WellDoneContainer: styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin: 20px 0 12px;
  `,
  WellDoneText: styled.div`
    font-size: 16px;
    font-weight: 700;
    color: ${({ theme }) => theme.colors.doneGreen};
  `,
};

export default Home;
